/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { Injectable } from '@angular/core';

/**
 * Provides the ActuatorApiConfiguration configuration object with a given root URL.
 */
export function provideActuatorApiConfiguration(rootUrl: string) {
  var config = new ActuatorApiConfiguration();
  config.rootUrl = rootUrl;
  return {
    provide: ActuatorApiConfiguration,
    useValue: config
  };
}

/**
 * Global configuration
 */
@Injectable({
  providedIn: 'root',
})
export class ActuatorApiConfiguration {
  rootUrl: string = '/';
}

